import type { EntityType } from 'types/entityType';

export const ENTITY_TYPE: EntityType = 'client';

export const TEST_ID = 'clientSelectPanelField';
